import { useEffect, useState } from 'react';

import { useClient } from './useClient';

export const useScreenSize = () => {
  const { isClient } = useClient();
  const [screenWidth, setScreenWidth] = useState(0);
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    if (!isClient) return;
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isClient]);

  return { screenWidth, screenHeight };
};
